import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompositionFilters, DEFAULT_COMPOSITION_FILTERS, DrawerCount } from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-composition-dtos';

@Component({
  selector: 'ng-casto-composition-filters',
  templateUrl: './composition-filters.component.html',
  styleUrl: './composition-filters.component.scss',
})
export class CompositionFiltersComponent implements OnInit {
  /** Contrôle l'affichage de la modale */
  @Input() isOpen: boolean = false;

  @Input() displayMode: 'modal' | 'inline' = 'modal';

  /** Filtres initiaux (optionnel) */
  @Input() initialFilters: CompositionFilters | null | undefined = DEFAULT_COMPOSITION_FILTERS;

  /** Émis quand l'utilisateur applique les filtres */
  @Output() filtersApplied = new EventEmitter<CompositionFilters>();

  /** Émis quand l'utilisateur continue sans filtrer */
  @Output() filterSkipped = new EventEmitter<void>();

  /** Émis quand l'utilisateur ferme la modale */
  @Output() closed = new EventEmitter<void>();

  /** Filtres en cours d'édition */
  filters: CompositionFilters;

  /** Valeur min/max pour le slider de largeur */
  readonly minWidth = 40;
  readonly maxWidth = 140;

  protected readonly DrawerCount = DrawerCount;

  /** Pourcentage pour le gradient du slider */
  get sliderPercentage(): number {
    return ((this.filters.maxFurnitureWidth - this.minWidth) / (this.maxWidth - this.minWidth)) * 100;
  }

  ngOnInit(): void {
    this.filters = { ...(this.initialFilters ?? DEFAULT_COMPOSITION_FILTERS) };
  }

  onDrawerCountSelect(value: DrawerCount | null): void {
    this.filters.drawerCount = value;
  }

  onWithNicheSelect(value: boolean | null): void {
    this.filters.withNiche = value;
  }

  onApplyFilters(): void {
    this.filtersApplied.emit({ ...this.filters });
  }

  onSkipFilters(): void {
    this.filterSkipped.emit();
  }

  onClose(): void {
    this.closed.emit();
  }
}
